import axios from 'axios';

axios.defaults.withCredentials = false;

axios.defaults.baseURL = /mingchezhantai/.test(location.host) ? 'https://api.mingchezhantai.com' : 'http://api.qichezhidao.com';
// axios.defaults.baseURL = 'http://localhost:8090';

axios.interceptors.request.use(request => {
    return request;
});

// 设置拦截器
axios.interceptors.response.use((response) => {
    return response;
}, (err) => {
    // if(err.response){

    // }
    return Promise.reject(err);
});
export default axios;
